export default __webpack_public_path__ + "static/media/download-icon.b7dbd034.svg";